import { DEDICATED_LANE_SEARCH_PAGE_SCROLL_Y } from '../constants'

export const scrollToLastPosition = () => {
  const scrollY = localStorage.getItem(DEDICATED_LANE_SEARCH_PAGE_SCROLL_Y)
  if (scrollY) {
    window.scrollTo({ top: Number(scrollY) })
    localStorage.removeItem(DEDICATED_LANE_SEARCH_PAGE_SCROLL_Y)
  }
}
